import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './se-background.css.lit';
import { classMap } from 'lit/directives/class-map.js';

export const backgroundVariants = ['wave', 'curves', 'none'] as const;

export type SeBackgroundVariant = typeof backgroundVariants[number];

export const backgroundCurveWidth = ['75', '50', '33'] as const;

export type SeBackgroundCurveWidth = typeof backgroundCurveWidth[number];

export const backgroundColors = ['primary-1', 'primary-2', 'white'] as const;

export type SeBackgroundColor = typeof backgroundColors[number];

export const backgroundAlignments = ['left', 'right', 'top', 'center'] as const;

export type SeBackgroundAlignment = typeof backgroundAlignments[number];

/**
 * The SeBackground component
 * @element se-background
 */
@customElement('se-background')
export class SeBackground extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  @property({ type: String })
  color: SeBackgroundColor = 'primary-2';

  @property({ type: String })
  variant: SeBackgroundVariant = 'curves';

  @property({ type: String })
  alignment: SeBackgroundAlignment = 'right';

  @property({ type: String, attribute: 'curve-width' })
  curveWidth = '50';

  @property({ type: Boolean, attribute: 'full-bleed' })
  fullBleed: boolean;

  render(): TemplateResult {
    const classes = {
      'background-panel': true,
      'wave': this.variant === 'wave',
      'curves': this.variant === 'curves',
      'full-bleed': this.fullBleed,
      [`position-${this.alignment}`]: this.alignment,
      [`brand-${this.color}`]: this.color,
      [`width-${this.curveWidth}`]: this.variant !== 'wave' && this.curveWidth,
    };
    return html`
      <div class="${classMap(classes)}">
        <slot></slot>
      </div>
    `;
  }
}
